const endPoints = {
  allNft: "listallnft",
  allCollection: "listallcollections",
  newCollection: "listallnewcollections",
  topMints: "listalltopmints",
  timeFrames: "filterspan",
};
export default endPoints;
